// extracted by mini-css-extract-plugin
export default {"policyArea":"Policy_policyArea__3e5El","inPolicyArea":"Policy_inPolicyArea__JTZaj","titlePolicy":"Policy_titlePolicy__WU6cj","textPolicy":"Policy_textPolicy__V9wWB"};